<div id="toggler" class="d-flex py-2" (click)="isCollapsed = !isCollapsed">
    <div class="col-1">
        <fa-icon [icon]="isCollapsed ? faChevronDown : faChevronUp" aria-hidden="true"></fa-icon>
    </div>
    <div class="col-3 user-select-auto text-break" id="material-num">
        {{ material.materialIdentifier.materialNumber.value }}
    </div>
    <div class="col-4 user-select-auto text-break">
        {{ material.description.value }}
        <ng-container *ngIf="displayAdditionalMaterialRequestInformation && material.orderInfoText">
            <fa-icon [icon]="faInfoCircle" class="ms-1" (click)="openInfoText($event, material.orderInfoText)">
            </fa-icon>
        </ng-container>
    </div>
    <div class="col-4 user-select-auto">
        {{ material.notificationIdentifier.qmNum }}
        <br />
        <span *ngIf="showStatusStringButton">
            <button (click)="openMaterialReturn()" class="btn btn-primary btn-sm">
                {{ material.statusString.value | translate }}
            </button>
        </span>
        <span *ngIf="showStatusString">{{ material.statusString.value | translate }}</span>
        <span *ngIf="showAwbReturn" class="content-break-word">{{ material.awbReturn.value }}</span>
    </div>
</div>
<div *ngIf="!isCollapsed" class="py-3 offset-1 d-lg-flex flex-lg-wrap">
    <div class="row align-items-center">
        <label
            translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_PURCHASE_NUMBER"
            class="col-6 col-lg-3 col-form-label text-start text-lg-end"
        ></label>
        <div class="col-6 col-lg-3 text-break">{{ material.materialIdentifier.orderNumber.value }}</div>

        <label
            translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_PURCHASE_ORDER"
            class="col-6 col-lg-3 col-form-label text-start text-lg-end"
        ></label>
        <div class="col-6 col-lg-3 text-break">{{ material.materialIdentifier.orderPosition.value }}</div>

        <label
            translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_BATCH_NUMBER"
            class="col-6 col-lg-3 col-form-label text-start text-lg-end"
        ></label>
        <div class="col-6 col-lg-3 text-break">{{ material.batchNumber.value }}</div>

        <label
            translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_RETURN_LOCATION"
            class="col-6 col-lg-3 col-form-label text-start text-lg-end"
        ></label>
        <div class="col-6 col-lg-3">
            <fa-icon
                *ngIf="
                    material.materialStatus.isReturnedOrRequested &&
                    material.deliveryReturnSelectedOption === customerAddress
                "
                [icon]="faUsers"
            >
            </fa-icon>
            <fa-icon
                *ngIf="
                    material.materialStatus.isReturnedOrRequested &&
                    material.deliveryReturnSelectedOption === dopAddress
                "
                [icon]="faBuilding"
            >
            </fa-icon>
            <fa-icon
                *ngIf="
                    material.materialStatus.isReturnedOrRequested &&
                    material.deliveryReturnSelectedOption === taxiAddress
                "
                [icon]="faTaxi"
            >
            </fa-icon>
            <span class="ps-2" *ngIf="displayAdditionalMaterialRequestInformation && material.orderPriority">
                <fa-icon *ngIf="material.orderPriority === HIGH" [icon]="faLongArrowAltUp"></fa-icon>
                <fa-icon *ngIf="material.orderPriority === MEDIUM" [icon]="faAngleDoubleUp"></fa-icon>
                <fa-icon *ngIf="material.orderPriority === LOW" [icon]="faAngleDoubleDown"></fa-icon>
            </span>
        </div>

        <label
            translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_DATE"
            class="col-6 col-lg-3 col-form-label text-start text-lg-end"
        ></label>
        <div class="col-6 col-lg-3 text-break">{{ material.activityDate.formattedDisplayedDate }}</div>

        <label
            translate="DASHBOARD_SIDEMENU_MATERIAL_HISTORY_AWB_PACKAGING"
            class="col-6 col-lg-3 col-form-label text-start text-lg-end"
        ></label>
        <div class="col-6 col-lg-3 text-break">{{ material.awbPackaging.value }}</div>
    </div>
</div>
